import { DMPEVENT, Packet, Loader } from '@/app/modules/Metrics/loaders/OneDMP';

const service = new Loader();

export interface FirstDMPPacketData {
    avocation: string;
    extid: string;
    one_dmp_id: string;
    mac: string;
}

export function install(firstPacket: FirstDMPPacketData) {
    return service.bootstrap({
        first_packets: [
            {
                event: DMPEVENT.USERDATA,
                data: firstPacket,
            },
        ],
    });
}

export function send(packet: Packet) {
    if (packet == null) {
        return;
    }

    service.send(packet);
}
